if(window.location.pathname === '/cart') {
   setTimeout(()=>{
      BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false,false,false)
   },2000)
}

setTimeout(()=>{
    setTimeout(() =>{
    function handleButtonClick(e) {
      if(BSS_B2B?.cart?.updatedLineItems?.length) {
        e.preventDefault();
        const button=(this);
        let oldText = $(this).text();
        $button.css({'pointer-events': 'none', 'opacity': '0.6'});
        $button.text("Loading ...");
        setTimeout(() =>{
          $button.css({'pointer-events': 'unset', 'opacity': '1'})
            $button.text(oldText);
        }, 2000);
      }
    }

   $(document).on('click dblclick', 'button[name="checkout"]', handleButtonClick);
  }, 500)

BSS_B2B.customTriggerCheckoutBtn = function(checkoutBtn){
    window.location.href = "/checkout";
  }
},2000)

BSS_BCP.addAction("custom_show_r4q", function ({ applyCartPage, quoteConfig, shopData, translations }) {    
    const r4qCartDrawerObserver = new MutationObserver(function (mutations, observer) {
      applyCartPage(shopData, BSS_BCP, quoteConfig, translations);
    });
    r4qCartDrawerObserver.observe(document.querySelector("cart-drawer"), { attributes: true })
  })
document.addEventListener("DOMContentLoaded", function () {
  const cartDrawerObserver = new MutationObserver(function (mutations, observer) {
    if (BSS_BCP?.netterm) {
      const oldNtButtons = document.querySelectorAll("cart-drawer .cart-drawer__checkout-buttons .bss-b2b-customer-portal-nt-checkout-btn");
      oldNtButtons.forEach((item) => item.remove());
      BSS_BCP.netterm.showButtonOnCartPage();
    }
  });
  cartDrawerObserver.observe(document.querySelector("cart-drawer"), { attributes: true });
});